import React from 'react';
import PropTypes from 'prop-types';

const NavbarLink = ({ url = '/video', className = 'navbar__link', isLink = true, clickHandler, target, key, text }) => {
    return (isLink ? (
                <a className={className} key={key} href={url} target={target}>
                    {text}
                </a>
            ) :
            (
                <span className={'navbar__text'} key={key} onClick={(e) => clickHandler(e)} style={{cursor: 'pointer'}}>
                    {text}
                </span>
            )
    );
};

NavbarLink.propTypes = {
    className: PropTypes.string,
    clickHandler: PropTypes.func,
    isLink: PropTypes.bool,
    key: PropTypes.string,
    target: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string
};

export default NavbarLink;
